<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',

  data() {
    return {
      lockedFullPath: '',
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler(route, prevRoute) {
        this.lockedFullPath = route.fullPath

        // Telas como BookingList usam só o hash (#booking) para o modal.
        // Não empilhar trap nessas trocas — isso causa loop push/pop do hash.
        const hashOnlyChange =
          prevRoute &&
          route.path === prevRoute.path &&
          this.sameQuery(route.query, prevRoute.query) &&
          route.hash !== prevRoute.hash

        if (!hashOnlyChange) {
          this.$nextTick(() => this.armBackTrap())
        }
      },
    },
  },

  mounted() {
    window.addEventListener('popstate', this.handleBrowserBack)
  },

  beforeDestroy() {
    window.removeEventListener('popstate', this.handleBrowserBack)
  },

  methods: {
    sameQuery(a = {}, b = {}) {
      return JSON.stringify(a) === JSON.stringify(b)
    },

    pathWithoutHash(fullPath) {
      return String(fullPath || '').split('#')[0]
    },

    syncLockedPathFromLocation() {
      this.$nextTick(() => {
        this.lockedFullPath =
          (this.$route && this.$route.fullPath) ||
          window.location.pathname +
            window.location.search +
            window.location.hash
      })
    },

    armBackTrap() {
      const state = window.history.state || {}
      if (state.__janooBackTrap) return
      window.history.pushState(
        { ...state, __janooBackTrap: true },
        document.title,
        window.location.href
      )
    },

    handleBrowserBack() {
      const closeButton = this.findVisibleCloseButton()
      const lockedHadHash = String(this.lockedFullPath || '').includes('#')

      // Histórico gerenciado pela tela (ex.: #booking no BookingList):
      // não reescrever URL nem clicar no close — o popstate local já cuida.
      if (lockedHadHash) {
        this.syncLockedPathFromLocation()
        return
      }

      // Modal/painel com button.close e sem hash próprio
      if (closeButton) {
        closeButton.click()
        this.syncLockedPathFromLocation()
        return
      }

      const target =
        this.pathWithoutHash(this.lockedFullPath) ||
        (this.$route && this.pathWithoutHash(this.$route.fullPath)) ||
        window.location.pathname + window.location.search

      window.history.pushState(
        { ...(window.history.state || {}), __janooBackTrap: true },
        document.title,
        target
      )

      if (this.$route && this.pathWithoutHash(this.$route.fullPath) !== target) {
        this.$router.replace(target).catch(() => {})
      }
    },

    findVisibleCloseButton() {
      const candidates = Array.from(
        document.querySelectorAll('button.close')
      ).filter((el) => this.isElementVisible(el))

      if (!candidates.length) return null
      return candidates[candidates.length - 1]
    },

    isElementVisible(el) {
      if (!el || el.disabled) return false

      if (typeof el.checkVisibility === 'function') {
        try {
          return el.checkVisibility({
            checkOpacity: true,
            checkVisibilityCSS: true,
          })
        } catch (error) {
          // fallback abaixo
        }
      }

      const style = window.getComputedStyle(el)
      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        Number(style.opacity) === 0 ||
        style.pointerEvents === 'none'
      ) {
        return false
      }

      const rect = el.getBoundingClientRect()
      return rect.width > 0 && rect.height > 0
    },
  },
}
</script>
